// Libraries
import styled from 'styled-components'

// Custom
import Globe from 'images/icons/globe.svg'
import GlobeActive from 'images/icons/globeHover.svg'

type LanguageSwitcherProps = {
  active: boolean
}

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  box-shadow: 3px 3px 14px rgba(190, 189, 189, 0.05);
  border-radius: 0px 0px 4px 4px;
  ::after {
    content: '';
    position: absolute;
    width: 50px;
    margin-top: 20px;
    height: 0.3px;
    background-color: #ced4da;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    width: 150px;
    ::after {
      display: none;
    }
  }
`

export const TitleContainer = styled.div<LanguageSwitcherProps>`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 52px;
  padding-top: 0px;
  background-color: ${({ theme }) => theme.colors.white02};
  font-family: ${({ theme }) => theme.fontFamily.lato};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.xsmall};
  color: ${({ theme }) => theme.colors.gray03};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    margin: 0px;
    padding-top: 0px;
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
    cursor: pointer;
    ::after {
      content: '';
      border: solid ${({ theme }) => theme.colors.blueDarkerLight};
      border-width: 0 3px 3px 0;
      border-radius: 3px;
      display: inline-block;
      padding: 4px;
      margin-left: 14.42px;
      transform: rotate(${({ active }) => active ? '45deg' : '-135deg'}); 
      -webkit-transform: rotate(${({ active }) => active ? '45deg' : '-135deg'});
      margin-top: ${({ active }) => active ? '-6px' : '2px'};
      transition: all .2s ease-in-out;
    }
  }
`

export const GlobeIcon = styled.div<LanguageSwitcherProps>`
  height: 20px;
  width: 20px;
  margin-right: 6px;
  background-image: url(${Globe});
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    background-image: url(${({ active }) => (active ? GlobeActive : Globe)});
  }
`

export const OptionsContainer = styled.div<LanguageSwitcherProps>`
  position: absolute;
  display: ${({active}) => active ? 'flex' : 'none'};
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white03};
  box-sizing: border-box;
  width: 150px;
  top: calc(100% + 29px);
  align-items: flex-start;
  padding: 22px 0px 6px 0px;
  border-radius: 0px 0px 4px 4px;
  box-shadow: 0px 1px 3px rgba(125, 125, 125, 0.1);
  z-index: 5;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    position: relative;
    padding: 31.5px 0px 10px 0px;
    width: 100%;
    top: 0px;
    display: flex;
    align-self: center;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.white02};
    box-shadow: 0px 0px 0px;
  }
`

export const LanguageOptions = styled.button<LanguageSwitcherProps>`
  background-color: transparent;
  border: none;
  margin-bottom: 24px;
  font-family: ${({ theme }) => theme.fontFamily.lato};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.xsmall};
  color: ${({ active }) =>
    active
      ? ({ theme }) => theme.colors.blueDarkerLight
      : ({ theme }) => theme.colors.gray04};
  cursor: pointer;
  :hover {
    color: ${({ theme }) => theme.colors.blueDarkerLight};
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktopMin}px) {
    margin: 0px 0px 10px 19px;
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    font-size: ${({ theme }) => theme.fontSize.xxsmall};
    color: ${({ active }) =>
      active
        ? ({ theme }) => theme.colors.purpleDarkest
        : ({ theme }) => theme.colors.gray04};
    :hover {
      color: ${({ theme }) => theme.colors.purpleDarkest};
    }
  }
`
